var map = {
	"./module_icon_light.svg": "dc96",
	"./module_icon_pudu.svg": "9a05",
	"./module_icon_puja.svg": "a29b",
	"./module_icon_treasury.svg": "4a0f",
	"./module_icon_worshipset.svg": "0a36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cedd";